import FileUploader from "@metacrm/metacrm-material-ui/dist/FileUploader";
import Popup from "@metacrm/metacrm-material-ui/dist/Popup";
import PreviewFile from "@metacrm/metacrm-material-ui/dist/PreviewFile";
import { Box } from "@mui/material";
import axios from "axios";
import LoadingIcon from "components/LoadingComponent/LoadingIcon";
import { apiUrl } from "features/configure";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useOutletContext } from "react-router";

export default function KbPDFModal({ onClose, onBack, refetch }) {
  const [isUploading, setIsUploading] = React.useState(false);
  const [file, setFile] = React.useState(null);
  const [entityName] = useOutletContext();

  const [isSaving, setIsSaving] = useState(false);

  const { formatMessage } = useIntl();
  function handleUpload(files) {
    setIsUploading(true);
    // upload file to server
    setFile(files[0]);

    setIsUploading(false);
  }

  const dispatchSnackbar = useDispatchSnackbar();

  async function handleSave() {
    try {
      setIsSaving(true);
      await axios.post(
        `${apiUrl}/api/knowledgeBase/pdf`,
        {
          entityName,
          name: file.name,
          file,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      await refetch();
      onClose();
    } catch (err) {
      dispatchSnackbar({ err });
    } finally {
      setIsSaving(false);
    }
  }

  const renderLook = () => {
    if (isUploading)
      return (
        <>
          <LoadingIcon />
          <Box mt="8px" color="#777" fontSize={12}>
            {formatMessage({ id: "global.status.uploading" })}
          </Box>
        </>
      );
    if (file) {
      return (
        <PreviewFile
          files={[file]}
          onDelete={(e) => {
            e.stopPropagation();
            setFile(null);
          }}
        />
      );
    }
    return (
      <>
        <i
          className="meta-crm-icon-ic_upload font-size-42"
          style={{ color: "#7B61FF" }}
        />
        <Box mt="12px" color="#222">
          {formatMessage({ id: "global.btn.uploadFile" })}
        </Box>
        <Box mt="4px" color="#777" fontSize={12}>
          {formatMessage({ id: "global.btn.uploadFileDescription" })}
        </Box>
      </>
    );
  };

  return (
    <Popup
      open={true}
      onClose={onClose}
      title={
        <Box className="item-flex">
          <img
            src={require("assets/img/ic_arrow_left.svg").default}
            onClick={onBack}
            style={{ cursor: "pointer", color: "#555", marginRight: "4px" }}
            width={24}
            height={24}
          />
          <Box fontSize={20}>
            {formatMessage({ id: "popup.createKnowledge.fromFile.title" })}
          </Box>
        </Box>
      }
      size="md"
      showFooter={true}
      onCancel={onClose}
      onConfirm={handleSave}
      confirmText="Add"
      confirmProps={{ isLoading: isSaving, disabled: !file }}
    >
      <Box display="flex" flexDirection="column" gap="24px 0">
        <FileUploader
          uploadFile={handleUpload}
          dropZoneProps={{
            accept: {
              "application/pdf": [".pdf"],
            },
          }}
          renderLook={
            <Box
              sx={{
                width: "100%",
                height: "280px",
                border: file ? "0.5px solid #555" : "0.5px dashed #555",
                borderRadius: "3px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              {renderLook()}
            </Box>
          }
        />
      </Box>
    </Popup>
  );
}
